export const questionTypes = Object.freeze({
  CHOICE: "CHOICE",
  TEXT: "TEXT",
  CONDITIONAL: "CONDITIONAL",
});

export const CandidateRequirements = Object.freeze({
  YEAR_OF_EXPERIENCE: "YEAR OF EXPERIENCE",
  UPLOAD_CV: "UPLOAD CV",
  PERSONAL_LETTER: "PERSONAL LETTER",
  DRIVING_LICENSE: "DRIVING LICENSE",
  // OTHER_DOCUMENTS: "OTHER DOCUMENTS",
});

export const allowedFileTypes = Object.freeze([
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/webp",
]);
